import {useAppSelector} from "../../store/hooks";
import {ViewType} from "../../view_type/ViewType";

export const useOfferPagePromotionTrackingIds = () => {
    const viewType = useAppSelector((state) => state.viewType.current);
    const property = useAppSelector((state) => state.property.property);
    const offer = useAppSelector((state) => state.offerDetail.offer);

    if (viewType === ViewType.PROPERTY && property) {
        return {
            offerId: property.offer.id,
            propertyId: property.id
        };
    }

    if (offer) {
        return {
            offerId: offer.id,
            propertyId: null as number | null
        };
    }

    if (property) {
        return {
            offerId: property.offer.id,
            propertyId: property.id
        };
    }

    return null;
};
import {useAppSelector} from "../../store/hooks";
import {ViewType} from "../../view_type/ViewType";

export const useOfferPagePromotionTrackingIds = () => {
    const viewType = useAppSelector((state) => state.viewType.current);
    const property = useAppSelector((state) => state.property.property);
    const offer = useAppSelector((state) => state.offerDetail.offer);

    if (viewType === ViewType.PROPERTY && property) {
        return {
            offerId: property.offer.id,
            propertyId: property.id
        };
    }

    if (offer) {
        return {
            offerId: offer.id,
            propertyId: null as number | null
        };
    }

    if (property) {
        return {
            offerId: property.offer.id,
            propertyId: property.id
        };
    }

    return null;
};
